<template>
  <div class="org-settings">
    <el-row :gutter="20">
      <!-- 机构信息 -->
      <el-col :span="12">
        <el-card>
          <div slot="header">
            <span>机构信息</span>
          </div>
          <el-form :model="orgForm" label-width="100px" ref="orgForm">
            <el-form-item label="机构名称" prop="orgName">
              <el-input v-model="orgForm.orgName" placeholder="请输入机构名称"></el-input>
            </el-form-item>
            <el-form-item label="机构简介" prop="description">
              <el-input type="textarea" v-model="orgForm.description" :rows="3" placeholder="请输入机构简介"></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="contactName">
              <el-input v-model="orgForm.contactName" placeholder="请输入联系人姓名"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input v-model="orgForm.contactPhone" placeholder="请输入联系电话"></el-input>
            </el-form-item>
            <el-form-item label="联系邮箱" prop="contactEmail">
              <el-input v-model="orgForm.contactEmail" placeholder="请输入联系邮箱"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="saveOrgInfo" :loading="savingOrg">保存机构信息</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>

      <!-- 收款账户 -->
      <el-col :span="12">
        <el-card>
          <div slot="header">
            <span>收款账户</span>
          </div>
          <el-form :model="bankForm" label-width="100px" ref="bankForm">
            <el-form-item label="银行名称" prop="bankName">
              <el-input v-model="bankForm.bankName" placeholder="如：中国工商银行"></el-input>
            </el-form-item>
            <el-form-item label="开户行" prop="bankBranch">
              <el-input v-model="bankForm.bankBranch" placeholder="如：北京市朝阳区支行"></el-input>
            </el-form-item>
            <el-form-item label="账户名" prop="accountName">
              <el-input v-model="bankForm.accountName" placeholder="请输入账户名"></el-input>
            </el-form-item>
            <el-form-item label="银行账号" prop="accountNumber">
              <el-input v-model="bankForm.accountNumber" placeholder="请输入银行账号"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="saveBankAccount" :loading="savingBank">保存收款账户</el-button>
            </el-form-item>
          </el-form>

          <el-divider></el-divider>

          <div class="commission-info">
            <h4>佣金信息</h4>
            <el-descriptions :column="1" border>
              <el-descriptions-item label="佣金比例">{{ orgInfo.commissionRate || 10 }}%</el-descriptions-item>
              <el-descriptions-item label="累计佣金">¥{{ orgInfo.totalCommission || '0.00' }}</el-descriptions-item>
              <el-descriptions-item label="已提现">¥{{ orgInfo.withdrawnCommission || '0.00' }}</el-descriptions-item>
              <el-descriptions-item label="可提现">
                <span class="available-amount">¥{{ availableCommission }}</span>
              </el-descriptions-item>
            </el-descriptions>
            <el-button type="warning" style="margin-top: 15px" :disabled="availableCommission <= 0">
              申请提现
            </el-button>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getOrgInfo, updateOrgInfo, updateBankAccount } from '@/api/organization'

export default {
  name: 'OrgSettings',
  data() {
    return {
      orgInfo: {},
      orgForm: {
        orgName: '',
        description: '',
        contactName: '',
        contactPhone: '',
        contactEmail: ''
      },
      bankForm: {
        bankName: '',
        bankBranch: '',
        accountName: '',
        accountNumber: ''
      },
      savingOrg: false,
      savingBank: false
    }
  },
  computed: {
    availableCommission() {
      const total = parseFloat(this.orgInfo.totalCommission) || 0
      const withdrawn = parseFloat(this.orgInfo.withdrawnCommission) || 0
      return (total - withdrawn).toFixed(2)
    }
  },
  created() {
    this.loadOrgInfo()
  },
  methods: {
    async loadOrgInfo() {
      try {
        const res = await getOrgInfo()
        if (res.code === 1) {
          this.orgInfo = res.data || {}
          // 填充表单
          this.orgForm = {
            orgName: this.orgInfo.orgName || '',
            description: this.orgInfo.description || '',
            contactName: this.orgInfo.contactName || '',
            contactPhone: this.orgInfo.contactPhone || '',
            contactEmail: this.orgInfo.contactEmail || ''
          }
          this.bankForm = {
            bankName: this.orgInfo.bankName || '',
            bankBranch: this.orgInfo.bankBranch || '',
            accountName: this.orgInfo.accountName || '',
            accountNumber: this.orgInfo.accountNumber || ''
          }
        }
      } catch (e) {
        console.error('加载机构信息失败:', e)
      }
    },
    async saveOrgInfo() {
      this.savingOrg = true
      try {
        const res = await updateOrgInfo(this.orgForm)
        if (res.code === 1) {
          this.$message.success('机构信息保存成功')
        } else {
          this.$message.error(res.msg || '保存失败')
        }
      } catch (e) {
        this.$message.error('保存失败')
      } finally {
        this.savingOrg = false
      }
    },
    async saveBankAccount() {
      this.savingBank = true
      try {
        const res = await updateBankAccount(this.bankForm)
        if (res.code === 1) {
          this.$message.success('收款账户保存成功')
        } else {
          this.$message.error(res.msg || '保存失败')
        }
      } catch (e) {
        this.$message.error('保存失败')
      } finally {
        this.savingBank = false
      }
    }
  }
}
</script>

<style scoped>
.org-settings {
  padding: 20px;
}

.commission-info h4 {
  margin-bottom: 15px;
  color: #333;
}

.available-amount {
  color: #67c23a;
  font-weight: bold;
  font-size: 16px;
}
</style>
